import script from "./AIAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AIAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=61b2dfbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b2dfbf"]])

export default __exports__